import { BrowserRouter } from 'react-router-dom';
import { ApolloProvider } from '@apollo/client/react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { client } from './infrastructure/graphql/client';
import { AuthProvider } from './presentation/contexts/AuthContext';
import AppRoutes from './routes/AppRoutes';
import './App.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30 * 60 * 1000,
      gcTime: 60 * 60 * 1000,
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <ApolloProvider client={client}>
          <AuthProvider>
            <AppRoutes />
          </AuthProvider>
        </ApolloProvider>
      </BrowserRouter>
    </QueryClientProvider>
  );
}

export default App;